import type { Trim } from "@dealer-center/inventory-pages-gvm-interface";
import type { MutableRefObject } from "react";

export const trimValidationPrefix = "validation-";
export const trimInputIdPrefix = "property-override-";

export function hasChanges(
  inputValues: MutableRefObject<Record<string, string>>,
  referenceTrim: Trim
) {
  for (const key in inputValues.current) {
    if (key.startsWith(trimValidationPrefix)) {
      continue;
    }
    const referenceValue = String(referenceTrim[key as keyof Trim] ?? "");
    if (inputValues.current[key] !== referenceValue) {
      return true;
    }
  }
  return false;
}
